import { ModulesFormRegistryEntry } from '../../../contexts'
import { productApplicationSliderFactory } from '../ProductApplicationSlider.factory'

export const productApplicationSliderModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './ProductApplicationSlider.form.vue'),
  factory: productApplicationSliderFactory,
  icon: require('../productApplicationSlider.svg'),
  label: 'modulesForms.ProductApplicationSlider._name',
  // restrictions: {
  //   allowedTypes: ['product', 'snippet']
  // }
}
